export default __webpack_public_path__ + "static/media/manage_rate_icon.4f52c6ad.svg";